/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LocationsAndLocationGroupsService {

    /**
     * List Locations
     * List all Locations within your account.
     * @param xAccessToken
     * @param brandId Brand ID to filter locations by
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiWxLocations(
        xAccessToken: string,
        brandId?: string,
    ): CancelablePromise<{
        locations?: Array<{
            /**
             * Unique identifier for the account
             */
            account_id: string;
            /**
             * Unique identifier for the location
             */
            id: string;
            /**
             * Address for the location
             */
            address?: string;
            /**
             * Street address of the location
             */
            street_address?: string;
            /**
             * City of the location
             */
            city?: string;
            /**
             * State code of the location
             */
            state_code?: string;
            /**
             * Postal code of the location
             */
            postal_code?: string;
            /**
             * Country code of the location
             */
            country_code?: string;
            location_group: {
                /**
                 * Unique identifier for the location group
                 */
                id: string;
                /**
                 * The name for the location group
                 */
                name: string;
                /**
                 * The owner of the location group
                 */
                owner: string;
            };
            /**
             * The name of the location
             */
            name: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/locations',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}